import VectorSource from 'ol/source/Vector';
import { isoTimeFormatter } from '../utils/DateUtils';
import { urlGenerator } from '../utils/urlUtils';
import { getKeyForParams } from './VectorTileWMS';

function urlFunction() {
  const urlParams = { ...this.params,
    time: this.params.time ? this.formatTime(this.params.time) : null
  };
  return urlGenerator(urlParams, this.getUrl());
}

class VectorSourceWMS extends VectorSource {
  constructor({
    params,
    timeFormatter,
    ...options
  }) {
    super(options);
    this.params = params || {};
    this.formatTime = timeFormatter || isoTimeFormatter;
    this.isLayerVisibleFn = options.isLayerVisibleFn;
    this.setLoader(options.loader(urlFunction.bind(this), options.format));
  }

  setKey(key) {
    // eslint-disable-next-line no-underscore-dangle
    this.key_ = key;
    this.changed();
  }

  updateParams(params) {
    Object.assign(this.params, params);
    this.setKey(getKeyForParams(this.params));
  }

}

export default VectorSourceWMS;